export interface UserType {
	userTypeId : number
}

export const  VendorUserAdmin : UserType = {
	userTypeId : 1
}

export const  VendorUser : UserType = {
	userTypeId : 2
}

export const  BuyerAdmin : UserType = {
	userTypeId : 3
}

export const  BuyerUser : UserType = {
	userTypeId : 4
}

export const  SuperAdmin : UserType = {
	userTypeId : 5
}

export const  SuperUser : UserType = {
	userTypeId : 6
}

export const  DiversityAdmin : UserType = {
	userTypeId : 7
}

export const  DiversityUser : UserType = {
	userTypeId : 8
}

export const  MemberAdmin : UserType = {
	userTypeId : 9
}
export const  MemberUser : UserType = {
	userTypeId : 10
}